const trackingName = 'marketing-tracking';

if (window.location.href.indexOf("c") > -1) {

    let url = new URL(window.location.href);
    let c = url.searchParams.get("c");

    if( c === "1" ) {
        setWithExpiry(trackingName, 1, 60 * 60 * 24 * 365);
    }

}

function setWithExpiry(key, value, ttl) {
    const now = new Date()

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item));
}


function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

function getMarketingStatus() {
    return getWithExpiry(trackingName)
}


window.onload = function () {
    if( ! getWithExpiry(trackingName) ) {
        jQuery("body").addClass("has-no-url-c");
    }
}



jQuery(document).ready(function ($) {

    const domain = 'getabstract.com';

    const c = findReGetParameter('c');
    const u = findReGetParameter('u');
    const utm_source = findReGetParameter('utm_source');
    const utm_medium = findReGetParameter('utm_medium');
    const utm_campaign = findReGetParameter('utm_campaign');
    const utm_term = findReGetParameter('utm_term');
    const utm_content = findReGetParameter('utm_content');

    const ut = findReGetParameter('ut');
    const ga = findReGetParameter('ga');

    jQuery("a").each(function( index ) {
        if((c != '' && c != null)){
            addAddReParameter(this, index, 'c', c, domain);
        }
        if((u != '' && u != null)){
            addAddReParameter(this, index, 'u', u, domain);
        }
        if((utm_source != '' && utm_source != null)){
            addAddReParameter(this, index, 'utm_source', utm_source, domain);
        }
        if((utm_source != '' && utm_source != null)){
            addAddReParameter(this, index, 'utm_source', utm_source, domain);
        }
        if(utm_medium != '' && utm_medium != null){
            addAddReParameter(this, index, 'utm_medium', utm_medium, domain);
        }
        if(utm_campaign != '' && utm_campaign != null){
            addAddReParameter(this, index, 'utm_campaign', utm_campaign, domain);
        }
        if(utm_term != '' && utm_term != null){
            addAddReParameter(this, index, 'utm_term', utm_term, domain);
        }
        if(utm_content != '' && utm_content != null){
            addAddReParameter(this, index, 'utm_content', utm_content, domain);
        }

        if(ut != '' && ut != null){
            addAddReParameter(this, index, 'ut', ut, domain);
        }
        if(ga != '' && ga != null){
            addAddReParameter(this, index, 'ga', ga, domain);
        }
    });

});

function addAddReParameter (element, index, key, value, domain){
    let myA = jQuery(element);
    // Only add parameter if we are …
    // … a) still on the same domain and …
    // … b) the parameter isn't in the link already

    if(myA.attr('href').search(domain) > 0 ){

        let connector = "&";

        if(myA.attr('href').search(/\u003F/g) == -1){
            connector = "?";
        }
        myA.attr('href', myA.attr('href')+connector+key+"="+value);
    }
}

function findReGetParameter(parameterName) {
    let result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}
